import { Avatar, Box, CircularProgress, Container, CssBaseline, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Toolbar, Typography } from "@mui/material";
import { Business as BusinessIcon, ArrowForward as ArrowForwardIcon } from "@mui/icons-material"
import { useQuery, useQueryClient } from "react-query";
import { getCompaniesByUser } from "./services/api";
import { useNavigate } from "react-router-dom";

export default function Company() {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem('mqadusr'))
  const queryClient = useQueryClient()
  const { data } = useQuery(
    ['companiesByUser', user._id], () => getCompaniesByUser(user._id),
    { refetchOnWindowFocus: false }
  )

  const handleSelectCompany = (company) => {
    const user = JSON.parse(localStorage.getItem('mqadusr')) 
    user.company = company
    localStorage.setItem('mqadusr', JSON.stringify(user))
    navigate("/admin/dashboard")
  }

  return (
    <>
      <CssBaseline />
      <Box component="main">
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Paper className="peperdashboard" sx={{ p: 2, textAlign: "center" }}>
            <Typography variant="h6" component="p">Selecciona una empresa</Typography><Divider sx={{ marginTop: 2, marginBottom: 2 }}/>
            {data !== undefined ?
              <List sx={{ width: '100%', maxWidth: 360, bgcolor: '#F3F4F6', margin: "0 auto" }}>
                {data.data.map((company, index) => (
                  <ListItem
                    key={`${index}-${company._id}`}
                    secondaryAction={
                      <IconButton edge="end" aria-label="next" onClick={() => handleSelectCompany(company)}>
                        <ArrowForwardIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <BusinessIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={company.name} />
                  </ListItem>
                ))}
              </List>
              : <CircularProgress />}
          </Paper>
        </Container>
      </Box>
    </>
  )
}